import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import PaginatorCustom from '../../components/paginationCustom';
import { getAuditLogsForSession } from './actions/SchedulingActions';
import SortingCustom from '../../components/SortingCustom';
import { reduxForm, reset } from 'redux-form';
import SmallLoader from '../../img/small-loader.gif';
import { showFormatedDate, resetFiltersAndSorting, showFormatedDateandTime } from '../../actions/utilAction';

class SessionAuditLogModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AppointmentId: props.appointmentId,
            open: true,
            isBillableSession: props.isBillableSession,            
        };
        this.filter = {
            sort_Column: 'logdate',
            sort_Order: 'desc',
            searchText: '',
        };
        this.setSortColumn = this.setSortColumn.bind(this);
        // this.handleReset = this.handleReset.bind(this);
        // this.handleSearchAuditLogForSession = this.handleSearchAuditLogForSession.bind(this);
    }
    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'logDate',
            sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
            contain_filters: {
                AppointmentId: this.state.AppointmentId ? this.state.AppointmentId : null,
                // FromDate: this.state.FromDate ? this.state.FromDate : '',
                // ToDate: this.state.ToDate ? this.state.ToDate : '',
            },
            pageNumber: page_number ? page_number : 1,
            // pageSize: GlobalVariables.pageSize,
        };
        this.props.getAuditLogsForSession(searchObj);
    }
    componentWillMount() {
        this.loadData();
    }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;

            this.loadData();
        }
    }
    // handleSearchAuditLogForSession(event) {
    //     // event.preventDefault();
    //     this.setState({
    //         AppointmentId: event.AppointmentId ? event.AppointmentId : '',
    //     }, () => {
    //         this.loadData();
    //     });
    // }
    // handleReset = () => {
    //     this.props.dispatch(reset('SessionAuditLogModalForm'));
    //     resetFiltersAndSorting(this.filter, 'claimid', true);
    //     this.setState({
    //         AppointmentId: null,

    //     }, () => {
    //         this.loadData();
    //     });
    // };
    renderData() {
        return this.props.auditLogForSessionData.data.SessionAuditLogs.map((data, index) => {
            return (
                <tr key={index}>
                    <td>{showFormatedDateandTime(data.logDate)}</td>
                    <td>{data.loggedBy}</td>
                    <td>{data.action}</td>
                    <td>
                        {data.isSignature === 'YES' ? 
                             (data.signatoryName || '')
                        :
                           null
                        }
                        {data.isSignature === 'YES' && data.signeeName !== '' ? <div> <span>({data.signeeName})</span></div> : null}
                    </td>
                    <td>{data.columnName || '-'}</td>
                    <td>
                        {data.isSignature === 'YES' ? 
                            <img className="img-fluid" src={`data:image/png;base64,${data.oldSignatures}`} alt={''} />
                        :
                            ((data.columnName === 'Session Clock In Time' || data.columnName === 'Session Clock Out Time') ? (data.oldValue ? showFormatedDateandTime(data.oldValue) : '') :  (data.oldValue || '-'))
                        }
                        {data.isSignature === 'YES' ? (data.oldSignDate === '1900-01-01T00:00:00' ? '' : <span>Date: {showFormatedDateandTime(data.oldSignDate)}</span>) : null}
                    </td>
                    <td>
                        {data.isSignature === 'YES' ? 
                            <img className="img-fluid" src={`data:image/png;base64,${data.newSignatures}`} alt={''} />
                        :
                            ((data.columnName === 'Session Clock In Time' || data.columnName === 'Session Clock Out Time') ? (data.newValue ? showFormatedDateandTime(data.newValue) : '') :  (data.newValue || '-'))
                        }
                        {data.isSignature === 'YES' ?  (data.newSignDate === '1900-01-01T00:00:00' ? '' : <span>Date: {showFormatedDateandTime(data.newSignDate)}</span>) : null}
                    </td>
                </tr>
            );
        });
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ?
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                    : null}
            </div>
        );
    }


    render() {
        let sessionDetail = null;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        if (this.props.auditLogForSessionData.data && this.props.auditLogForSessionData.data.SessionDetail) {
            sessionDetail = this.props.auditLogForSessionData.data.SessionDetail;
        }
        return (
            <Dialog className="custom_modal_new_appointment"
                title='Session Notes Logs'
                modal={false}
                open={this.state.open}
                autoScrollBodyContent={true}>
                {this.renderLoading()}

                <div>
                    <div className="clearfix"></div>
                    <div className="readmin-panel mt-20">
                        <div className="panel-body">
                            <div className="col-sm-12 mtm-40">
                                {/* <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchAuditLogForSession)}>
                                    <div className="col-sm-4">
                                    <Field name="AppointmentId"
                                        autoFocus={true}
                                        floatingLabelText="Claim Id"
                                        // onChange={this.handleSearchChange}
                                        component={renderTextField} />
                                    </div>

                                    <div className="row">
                                    <div className="col-sm-12 btn_rt reset-btn">
                                        <RaisedButton label="Filter" className="grey_btn" type="Submit" primary={true} />
                                        <RaisedButton label="Reset" className="grey_btn ml_15" onTouchTap={this.handleReset} />
                                    </div>
                                    </div>
                                </form> */}
                                <div className="row cliam_hisdeatil">                                   
                                    <div className="col-sm-6">
                                        <p>DOS : <span>{sessionDetail ? showFormatedDate(sessionDetail.dateOfService) : '-'}</span></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>Appointment Type Name : <span>{sessionDetail ? sessionDetail.appointmentTypeName : '-'}</span></p>
                                    </div>
                                    {this.state.isBillableSession && <div className="col-sm-6">
                                        <p>Client Name : <span>{sessionDetail ? sessionDetail.patientName : '-'}</span></p>
                                    </div>}
                                    {this.state.isBillableSession && <div className="col-sm-6">
                                        <p>Insurance Company : <span>{sessionDetail ? sessionDetail.payerName : '-'}</span></p>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="table-responsive mt-15">
                                        {this.props.auditLogForSessionData.data && this.props.auditLogForSessionData.data.SessionAuditLogs && this.props.auditLogForSessionData.data.SessionAuditLogs.length ?
                                            <table className={tableClass}>
                                                <thead>
                                                    <tr>
                                                        <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='logdate' displayName='Log Date' /></th>
                                                        <th width="18%"><span>Logged By</span></th>                                                    
                                                        <th width="15%"><span>Action</span></th>                                                    
                                                        <th width="10%"><span>Name</span></th>
                                                        <th width="10%"><span>Field</span></th>
                                                        <th width="12%"><span>Old Value</span></th>
                                                        <th width="15%"><span>New Value</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.renderData()}
                                                </tbody>
                                            </table>
                                            :
                                            <table className={tableClass}>
                                                <thead>
                                                    <tr>
                                                        <th width="20%"><span>Log Date</span></th>   
                                                        <th width="18%"><span>Logged By</span></th>                                                    
                                                        <th width="15%"><span>Action</span></th>     
                                                        <th width="10%"><span>Name</span></th>
                                                        <th width="10%"><span>Field</span></th>
                                                        <th width="12%"><span>Old Value</span></th>
                                                        <th width="15%"><span>New Value</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="7">
                                                            <div className="familydl text-center no-record">No record found!</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        }

                                        {this.props.auditLogForSessionData.data && this.props.auditLogForSessionData.data.SessionAuditLogs && this.props.auditLogForSessionData.data.SessionAuditLogs.length ?
                                            <PaginatorCustom data={this.props.auditLogForSessionData.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                            : null}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 pt20 btn_rt">
                    <FlatButton className="grey_btn" label="Cancel" onTouchTap={this.handleClose} />
                </div>
            </Dialog>
        );
    }
}
SessionAuditLogModal = reduxForm({
    form: 'SessionAuditLogModalForm',
})(SessionAuditLogModal);

function mapStateToProps(state) {
    return {
        loading: state.scheduling.loading,
        auditLogForSessionData: state.scheduling.auditLogForSessionData,
    };

}
export default connect(mapStateToProps, { getAuditLogsForSession })(SessionAuditLogModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/SessionAuditLogModal.js